import React, { useCallback } from "react";
import { Box, H1, Text, Button, Typography } from "../components/ui";
import ScrollContainer from "components/general/ScrollContainer";
import Container from "components/general/Container";
import { useIsMobile } from "utils/hooks/useIsMobile";
import { useRouter } from "expo-router";

export default function PageNotFound() {
	const isMobile = useIsMobile();
	const router = useRouter();

	const handleGoHome = useCallback(() => {
		router.push("/");
	}, [router]);

	if (isMobile) {
		return (
			<Box bg="$neutral25" height="$full" display="flex" alignItems="center" justifyContent="center">
				<Container sx={{ justifyContent: "center", alignItems: "center" }}>
					<Box display="flex" flexDirection="column" alignItems="center" gap={16}>
						<H1>404 - Page Not Found</H1>
						<Text color="$neutral600" fontSize="$lg">
							The page you're looking for doesn't exist or has been moved.
						</Text>
						<Box mt={24}>
							<Button variant="secondary" onPress={handleGoHome}>
								<Typography weight="bold">Return to Home</Typography>
							</Button>
						</Box>
					</Box>
				</Container>
			</Box>
		);
	}
	return (
		<ScrollContainer withFooter={isMobile ? false : true}>
			<Box bg="$neutral25" height="$full" display="flex" alignItems="center" justifyContent="center">
				<Container>
					<Box display="flex" flexDirection="column" alignItems="center" gap={16}>
						<H1>404 - Page Not Found</H1>
						<Text color="$neutral600" fontSize="$lg">
							The page you're looking for doesn't exist or has been moved.
						</Text>
						<Box mt={24}>
							<Button variant="secondary" onPress={handleGoHome}>
								<Typography weight="bold">Return to Home</Typography>
							</Button>
						</Box>
					</Box>
				</Container>
			</Box>
		</ScrollContainer>
	);
}
